import { Outlet } from "react-router-dom";
import { useSidebarStore } from "@/components/SidebarStore";
import { useAuthStore } from "@/store/auth.store";
import Header from "./Header";
import SidebarLayout from "./Sidebar";

const Layout = () => {
	const { isSuperAdmin, isBrand } = useAuthStore();
	const collapsed = useSidebarStore((state) => state.collapsed);
	const setCollapsed = useSidebarStore((state) => state.setCollapsed);

	return (
		<div className="flex-md min-h-screen relative">
			<SidebarLayout
				collapsed={collapsed}
				setCollapsed={(value) =>
					typeof value === "function"
						? setCollapsed((value as (prev: boolean) => boolean)(collapsed))
						: setCollapsed(value)
				}
				isSuperAdmin={isSuperAdmin === "true"}
				isBrand={isBrand === "true"}
			/>
			<div
				className={`flex-1 flex flex-col transition-all duration-300 ${
					collapsed ? "ml-16" : "ml-64"
				}`}
			>
				<Header />
				<main className="p-6 flex-1 bg-gray-50 overflow-auto">
					<Outlet />
				</main>
			</div>
		</div>
	);
};

export default Layout;
